
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {
  display:block;
}

.full-video-cta {
  position:relative;
  background-size:cover;
  background-position:center;
}

.overlay{
  background:var(--horizontal-video-overlay-gradient);
}

@media (min-width: 1024px){

.overlay{
    background:var(--vertical-video-overlay-gradient)
}
  }

.container {
  position:relative;
  display:flex;
  flex-direction:column;
  justify-content:center;
  padding-left:1.25rem;
  padding-right:1.25rem;
  padding-bottom:2rem;
}

@media (min-width: 1024px) {

  .container {
    flex-direction:row;
  }

  .container {
    align-items:center;
  }

  .container {
    padding-left:0px;
    padding-right:0px;
  }

  .container {
    padding-bottom:0px;
  }
}

.container::after {
  display:block;
}

@media (min-width: 1024px) {

  .container::after {
    position:relative;
    padding-bottom:calc(var(--tw-aspect-h) / 16 * 100%);
    padding-bottom:calc(var(--tw-aspect-h) / var(--tw-aspect-w) * 100%);
    --tw-aspect-w:16;
  }
}

@media (min-width: 1024px) {

  .container::after > * {
    position:absolute;
    height:100%;
    width:100%;
    top:0;
    right:0;
    bottom:0;
    left:0;
  }
}

@media (min-width: 1024px) {

  .container::after {
    --tw-aspect-h:9;
  }
}

.container::after{
    content:'';
  }

.content {
  top:100%;
}

@media (min-width: 768px) {

  .content {
    bottom:4rem;
  }

  .content {
    right:2rem;
  }
}

@media (min-width: 1024px) {

  .content {
    position:absolute;
  }
}

@media (min-width: 1024px){

.content{
    width:calc(50% - 9rem);
    top:inherit
}
  }

.content .heading {
  margin-top:1.5rem;
}

.content .heading {
  margin-bottom:0px;
}

.content .heading {
  font-family:var(--ff-display);
}

.content .heading {
  font-size:var(--fs-3xl);
  line-height:var(--lh-3xl);
}

.content .heading {
  font-weight:var(--fw-bold);
}

.content .heading {
  color:var(--neutral-white);
}

@media (min-width: 1280px) {

  .content .heading {
    font-size:var(--fs-4xl);
    line-height:var(--lh-4xl);
  }
}

:host([site='GHS']) .player {
  margin-top:16rem;
}

:host([site='GHS']) .player {
  box-sizing:border-box;
}

:host([site='GHS']) .player {
  display:flex;
}

:host([site='GHS']) .player {
  height:75px;
}

:host([site='GHS']) .player {
  width:75px;
}

:host([site='GHS']) .player {
  cursor:pointer;
}

:host([site='GHS']) .player {
  align-items:center;
}

:host([site='GHS']) .player {
  justify-content:center;
}

:host([site='GHS']) .player {
  border-radius:9999px;
}

:host([site='GHS']) .player {
  border-style:none;
}

:host([site='GHS']) .player {
  background-color:var(--primary-blue-darker);
}

@media (min-width: 640px) {

  :host([site='GHS']) .player {
    height:8rem;
  }
}

@media (min-width: 640px) {

  :host([site='GHS']) .player {
    width:8rem;
  }
}

@media (min-width: 1024px) {

  :host([site='GHS']) .player {
    margin-top:0px;
  }
}

@media (min-width: 1024px) {

  :host([site='GHS']) .player {
    height:180px;
  }
}

@media (min-width: 1024px) {

  :host([site='GHS']) .player {
    width:180px;
  }
}

:host([site='GHS']) .player ghs-icon {
  color:var(--neutral-white);
}

:host([site='GHS']) .player:hover {
  opacity:0.9;
}

:host([site='GHS']) .player:focus {
  outline-style:dashed;
}

:host([site='GHS']) .player:focus {
  outline-width:1px;
}

:host([site='GHS']) .player:focus {
  outline-offset:4px;
}

:host([site='GHS']) .player:focus {
  outline-color:var(--neutral-white);
}

:host([site='GHS']) .player:disabled {
  cursor:not-allowed;
}

:host([site='GHS']) .player:disabled {
  opacity:0.75;
}

:host([site='GHS']) .mobile-icon {
  display:none;
}

.cta-btn {
  margin-top:1rem;
}

.video {
  position:absolute;
  bottom:0px;
  top:0px;
  left:0px;
  right:0px;
  margin-left:auto;
  margin-right:auto;
  box-sizing:border-box;
  display:none;
  max-width:1360px;
  background-color:var(--neutral-black);
}

.video--visible {
  display:block;
}

.video ghs-video-youtube {
  display:block;
}

.video ghs-video-youtube {
  height:100%;
}

.video ghs-video-youtube {
  padding-bottom:0px;
}

.full-video-cta.left .content {
  right:auto;
}

@media (min-width: 768px) {

  .full-video-cta.left .content {
    left:2rem;
  }
}

:host([site='BH']) .content{
    top:calc(50% + 2rem);
  }

@media (min-width: 1024px){

:host([site='BH']) .content{
      width:calc(50% - 7rem)
  }
    }

:host([site='BH']) .player {
  margin-top:16rem;
}

:host([site='BH']) .player {
  height:78px;
}

:host([site='BH']) .player {
  width:78px;
}

:host([site='BH']) .player {
  cursor:pointer;
}

:host([site='BH']) .player {
  border-width:0px;
}

:host([site='BH']) .player {
  background-color:var(--neutral-transparent);
}

@media (min-width: 1024px) {

  :host([site='BH']) .player {
    margin-top:0px;
  }
}

@media (min-width: 1024px) {

  :host([site='BH']) .player {
    height:350px;
  }
}

@media (min-width: 1024px) {

  :host([site='BH']) .player {
    width:350px;
  }
}

:host([site='BH']) .mobile-icon {
  display:block;
}

@media (min-width: 1024px) {

  :host([site='BH']) .mobile-icon {
    display:none;
  }
}

:host([site='BH']) .desktop-icon {
  display:none;
}

@media (min-width: 1024px) {

  :host([site='BH']) .desktop-icon {
    display:block;
  }
}

:host([site='BH']) .image-wrapper {
  position:absolute;
}

:host([site='BH']) .image-wrapper {
  z-index:0;
}

:host([site='BH']) .image-wrapper {
  display:flex;
}

:host([site='BH']) .image-wrapper {
  height:100%;
}

:host([site='BH']) .image-wrapper {
  width:100%;
}

:host([site='BH']) .overlay {
  position:relative;
}

:host([site='BH']) .overlay {
  z-index:10;
}

:host([site='BH']) .video {
  z-index:10;
}
`;